const scrollTo = (y) => {
    $('html,body').animate({ scrollTop: y }, 500);
};

const initialize = () => {
    $('a[href^="#"]:not(.revealer)').click(function(event) {
        event.preventDefault();
        const hash = this.hash;
        if (hash.length === 0) {
            if ($(this).hasClass('back-to-top')) {
                scrollTo(0);
                $('#contentArea').find('.hidden-aria-target').trigger('focus');
                return;
            }
        }
        if ($(hash).length === 0) return;
        const currentScrollTop = $(window).scrollTop();
        const elementTop = $(hash).offset().top;
        const newScrollTop = (
            elementTop > currentScrollTop
                ? elementTop
                : elementTop - $('[data-header-wrap]').height()
        );
        scrollTo(newScrollTop);
    });
};

export default {
    initialize,
};

